export const DEFAULT_LOCALE = "en-US";

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";

export const REGION = 'us-west-2';
export const STAGE = 'alpha';
export const AGENT_RUNTIME_ARN = 'arn:aws:bedrock-agentcore:us-east-1:215288575882:runtime/BlueyToolRefinementAgent_alpha-Nm6m6jEkbe';
export const TEST_CASE_AGENT_RUNTIME_ARN = 'arn:aws:bedrock-agentcore:us-east-1:215288575882:runtime/TestCaseAgent_alpha-Uo3jvi7J2l';

export const isArnConfigured = (arn: string): boolean =>
  arn !== '' && !arn.startsWith('{{');

export const CONFIG_GENERATOR_ENDPOINT = 'https://alpha.management.bluey.device.finance.amazon.dev';

// Tool Status Constants
export const TOOL_STATUS = {
  VALID: 'VALID',
  INVALID: 'INVALID'
} as const;

export type ToolStatus = typeof TOOL_STATUS[keyof typeof TOOL_STATUS];
